import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';
import { BancoService } from 'src/app/_services/banco.service';
import { CarteiraService } from 'src/app/_services/carteira.service';
import { Carteira } from 'src/app/_models/carteira/carteira';
import { Banco } from 'src/app/_models/banco/banco';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';

@Component({
  templateUrl: 'carteira.component.html',
  providers: [MessageService, ConfirmationService]
})

export class CarteiraComponent implements OnInit {

  carteiraDialog: boolean;
  carteiras: Carteira[];
  carteira: Carteira;
  carteiraNew: Carteira;
  selectedCarteira: Carteira[];
  submitted: boolean;
  cols: any[];

  bancos: Banco[];
  banco: Banco;
  filteredBancos: Banco[];
  perfil: Perfil;
  manterCarteira: string;
  labelHeader: string;
  header: any[];

  @ViewChild('dt', {read: '', static: true}) dt: any;

  constructor(private bancoService: BancoService, private carteiraService: CarteiraService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
              private authenticationService: AuthenticationService, private bscobrancaTranslate: BscobrancaTranslate) {
        this.manterCarteira = this.bscobrancaTranslate.getText('menu.manterCarteira');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterCarteira, routerLink: ['/carteira/carteira']  }
        ]);
        this.header = ['Codigo Banco', 'Nome Banco', 'Codigo Carteira Banco', 'Sigla Carteira', 'Descricao Carteira'];
    }


  ngOnInit(): void {
    this.bancoService.getAllBancoTodos().toPromise().then(data => this.bancos = data);
    this.carteiraService.getAllCarteiras().toPromise().then(data => this.carteiras = data);
    this.perfil = this.authenticationService.atualUserPerfilValue;
    this.cols = [
            { field: 'codBanco', header: 'Codigo Banco' },
            { field: 'nmeBanco', header: 'Nome Banco' },
            { field: 'dscCart', header: 'Descricao Carteira'},
            { field: 'siglaCart', header: 'Sigla Carteira'}
        ];
  }


  openNew() {
        this.carteira = {};
        this.banco = {};
        this.submitted = false;
        this.carteiraDialog = true;
  }

    deleteSelectedCarteira() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.carteiras = this.carteiras.filter(val => !this.selectedCarteira.includes(val));
                this.selectedCarteira = null;
                this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Carteira Excluida', life: 3000});
            }
        });
    }

    editCarteira(carteira: Carteira) {
        this.carteira = {...carteira};
        this.banco = this.carteira.banco;
        this.carteiraDialog = true;
    }

    deleteCarteira(carteira: Carteira) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.carteira-001') + carteira.desCarteiraBanco + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.carteiraService.deletar(carteira);
                this.carteiras = this.carteiras.filter(val => val.id !== carteira.id);
                this.carteira = {};
                this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000});
            }
        });
    }

    hideDialog() {
        this.carteiraDialog = false;
        this.submitted = false;
    }

    saveCarteira() {
        this.messageService.clear();
        this.submitted = true;
        this.carteiraNew = {};
        this.carteira.banco = this.banco;
        let mensagem = '';
        if (this.carteira.desCarteiraBanco === '' || this.carteira.desCarteiraBanco === null
            || this.carteira.desCarteiraBanco === undefined) {
                mensagem = this.bscobrancaTranslate.getText('mensagens.carteira-005');
        }
        if (this.carteira.codCarteira === '' || this.carteira.codCarteira === null
            || this.carteira.codCarteira === undefined) {
            mensagem = this.bscobrancaTranslate.getText('mensagens.carteira-010');
        }
        if (this.carteira.sglCarteiraBanco === '' || this.carteira.sglCarteiraBanco === null
            || this.carteira.sglCarteiraBanco === undefined) {
            mensagem = this.bscobrancaTranslate.getText('mensagens.carteira-012');
        }
        if (!this.banco || this.banco.codBanco === null
            || this.banco.codBanco === undefined) {
            mensagem = this.bscobrancaTranslate.getText('mensagens.carteira-011');
        }
        if (mensagem !== '') {
            this.messageService.add({severity: 'error', summary: 'Error', detail: mensagem, life: 5000});
        } else {
            if (this.carteira.desCarteiraBanco.trim()) {
                if (this.carteira.id != null) {
                    this.carteiraService.atualizar(this.carteira).toPromise().then(data => this.carteiraNew = data);
                    this.messageService.add({severity: 'success', summary: 'Successful',
                    detail: this.bscobrancaTranslate.getText('mensagens.carteira-006'), life: 3000});
                    this.carteiraService.getAllCarteiras().toPromise().then(data => this.carteiras = data);
                    this.carteiras = [...this.carteiras];
                }
                else {
                    this.carteiraService.inserir(this.carteira).toPromise().then(data => this.carteiraNew = data);
                    this.messageService.add({severity: 'success', summary: 'Successful',
                    detail: this.bscobrancaTranslate.getText('mensagens.carteira-008'), life: 3000});
                    console.log(this.carteira);
                    this.carteiras.push(this.carteira);
                    this.carteiraService.getAllCarteiras().toPromise().then(data => this.carteiras = data);
                    this.carteiras = [...this.carteiras];
                }
                this.carteiraDialog = false;
                this.carteira = {};
            }
        }
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.carteiras.length; i++) {
            if (this.carteiras[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

     filterBancos(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.bancos.length; i++) {
            const banco = this.bancos[i];
            if (banco.nmeBanco.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(banco);
            }
        }

        this.filteredBancos = filtered;
    }

    downloadFile(filename= 'carteiras') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
   }

   ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.carteiras.length; i++) {
             const carteira = this.carteiras[i];
             let line = (i + 1) + ';';
             line += carteira.banco.codBanco + ';';
             line += carteira.banco.nmeBanco + ';';
             line += carteira.codCarteira + ';';
             line += carteira.sglCarteiraBanco + ';';
             line += carteira.desCarteiraBanco + ';';
             str += line + '\r\n';
         }
         return str;
     }


}
